export var UserType;
(function (UserType) {
    UserType["Employee"] = "employee";
    UserType["Partner"] = "partner";
    UserType["Customer"] = "customer";
})(UserType || (UserType = {}));
//# sourceMappingURL=user-type.js.map